export function registerServiceWorker(): void {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('[PWA] ServiceWorker registration successful with scope: ', registration.scope);
        })
        .catch((error) => {
          console.warn('[PWA] ServiceWorker registration failed: ', error);
        });
    });
  }
}
